// src/components/ReferralPromptModal.js - VERSION FINALE AVEC RÔLE TEMPS RÉEL

import React, { useState, useEffect } from 'react';
import './ReferralPromptModal.css';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';

const ReferralPromptModal = ({ onClose, onLinkSubmit, errorMessage, isLoading, onProceedWithoutLink }) => {
    const [referralLink, setReferralLink] = useState('');
    const [userRole, setUserRole] = useState(null);
    const [fetchingRole, setFetchingRole] = useState(true);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setFetchingRole(false);
                    return;
                }

                const response = await axios.get('https://api.blackroq.pro/api/user/dashboard-data', {
                    headers: { Authorization: `Bearer ${token}` }
                });

                setUserRole(response.data.user?.role);
            } catch (error) {
                console.error('Erreur récupération rôle', error);
                setUserRole(null);
            } finally {
                setFetchingRole(false);
            }
        };

        fetchUserRole();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (referralLink.trim()) {
            onLinkSubmit(referralLink);
        } else {
            alert("Veuillez entrer un lien de parrainage.");
        }
    };

    if (fetchingRole) {
        return (
            <div className="referral-modal-overlay">
                <div className="referral-modal-content">
                    <p>Chargement de vos informations...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="referral-modal-overlay">
            <div className="referral-modal-content">
                
                <button className="close-btn" onClick={onClose}>
                    <FaTimes />
                </button> 
                
                <h3>Avez-vous un lien de parrainage ?</h3>
                
                {errorMessage && (
                    <div className="alert alert-danger p-2 mt-3 mb-3">
                        {errorMessage}
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Collez votre lien ici..."
                            value={referralLink}
                            onChange={(e) => setReferralLink(e.target.value)}
                            disabled={isLoading}
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        className="btn btn-primary mt-3 w-100" 
                        disabled={!referralLink.trim() || isLoading}
                    >
                        {isLoading ? 'Vérification...' : 'Soumettre'}
                    </button>
                    
                    {/* 👇 Bouton visible UNIQUEMENT pour le rôle 'alpha' */}
                    {userRole === 'alpha' && (
                        <button 
                            type="button" 
                            className="btn btn-secondary mt-2 w-100" 
                            onClick={onProceedWithoutLink}
                            disabled={isLoading}
                        >
                            Non, continuer sans lien
                        </button>
                    )}
                </form>
            </div>
        </div>
    );
};

export default ReferralPromptModal;